<template>
  <div class='GlobalSpinner'>
    <div class="black"></div>
    <div class="cont-spinner">
      <!-- <vue-spinner
      color="#000000"
      size="50"
      /> -->
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
      style="z-index: 999"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VueSpinner } from 'vue3-spinners'
import { loaders } from '@/components/Spinner'
export default {
  name: 'GlobalSpinner',
  components: { VueSpinner, ...loaders },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.GlobalSpinner {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1002;
  display: flex;
  justify-content: center;
  align-items: center;
}

.black {
  width: 100%;
  height: 100%;
  opacity: 0.50;
  position: absolute;
  background-color: #000000;
}

.cont-spinner {
  position: absolute;
}
</style>
